<div class="button-container">
	<button-bar
		[items]="addableProcedures"
		[extraItems]="extraAddableProcedures"
		[includeAddButton]="true"
		[theme]="theme"
		(onItemSelected)="itemSelected($event)"
		(onMouseOverItem)="mouseOverItem($event)"
		(clickOutside)="closeButtonBar()">
	</button-bar>
	<div class="current-mouse-over-item" [style.margin-left]="allowIfElse ? '' : '20px'">
		<span [innerHTML]="currentMouseOverItem?.htmlLabel || '&nbsp;'"></span>
	</div>
</div>
